/**
 * Created by Pradeep Kumar on 01/18/2019.
 */

export class CreepyCarnivalTwoGameMode {
    public static readonly RESPIN:string = "RESPIN_MAIN";
    public static readonly NORMAL: string = "NORMAL";
    public static readonly FREESPIN: string = "FREESPIN";
    public static readonly RESPIN_FREESPIN: string = "RESPIN_FREESPIN";
    public static readonly STAR_SPIN: string = "STAR_SPIN";
}